var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextImage',{attrs:{"headline":_vm.$t('beweissicherung.headline'),"subline":_vm.$t('beweissicherung.subline'),"text":_vm.$t('beweissicherung.text'),"image":"/assets/images/beweissicherung.jpeg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }